import { FC } from 'react';
import { BsGrid, BsGrid3X3Gap, BsTable } from 'react-icons/bs';

/** Типовые иконки видов для ViewSwitcher: таблица, карточки, мелкие значки. */
export const ViewIconTable: FC = () => <BsTable size={18} aria-hidden />;
export const ViewIconCards: FC = () => <BsGrid size={18} aria-hidden />;
export const ViewIconCompact: FC = () => <BsGrid3X3Gap size={18} aria-hidden />;
